import React, {useState} from 'react';
import PopUp from '../Popup/PopUp';
import BtnSubmit from '../Buttons/BtnSubmit';
import Config from '../../../Config';
import {connect} from 'react-redux';
import ShoppingCart from '../../Block/SaleJetBlock/Partials/ShoppingCart/ShoppingCart';
import iconBack from './images/icon-back.svg';
import cellcomLogo from './images/cellcomLogo.svg';
import icon100Hand from './images/icon-100-hand.svg';
import {getDataFromIContentRepo} from '../../../utilities/StringHelpers/StringHelpers';

const SalesHeader = (props) => {
  const [showLobbyPopup, setShowLobbyPopup] = useState(false);
  const [headerPopupAppearancesCount, setHeaderPopupAppearancesCount] = useState(0);
  const ignoreListTVAndCellular = ['welcomePage', 'productsPage', 'newNumberPage', 'chooseNumberPage', 'successPage'];
  const ignoreListFiber = ['addressFormPage', 'welcomePage', 'otpVerifyPhone', 'otpVerifyCode', 'successPage'];

  const siteLogo = getDataFromIContentRepo('siteLogo');
  const cellcomLogoUrl = Config.epiBaseUrl + siteLogo?.url;

  const goToLobby = () => {
    window.location.href = Config.staticWebSiteUrl;
  };

  const isShowPopup = () => {
    if (headerPopupAppearancesCount > 2) {
      goToLobby();
    } else {
      if (isRedirect()) {
        goToLobby();
      } else {
        setShowLobbyPopup(true);
        setHeaderPopupAppearancesCount(headerPopupAppearancesCount + 1);
      }
    }
  };

  const isRedirect = () => {
    if (props.saleType != 'internet') {
      if (ignoreListTVAndCellular.includes(props.currentPage)) {
        return true;
      }
    } else {
      if (ignoreListFiber.includes(props.currentPage)) {
        return true;
      }
    }
  };

  return (
    <div className='cellcom-sale-header'>
      <div className='back-wrapper'>
        <button className='back' style={{backgroundImage:iconBack.bg()}} onClick={() => window.history.back()} />
      </div>
      <div className='logo-wrapper'>
        <img src={cellcomLogoUrl} alt='cellcom logo' className="cellcom-logo"  onClick={() => isShowPopup()}/>
      </div>
      <div className='shopping-cart-wrapper'>
        <ShoppingCart/>
      </div>

      <PopUp className='cellcom-sale-lobby-popup' showPopUp={showLobbyPopup} onClose={() => setShowLobbyPopup(false)}>
        <div className='popup_content'>
          <div className='icon-leave' style={{backgroundImage:icon100Hand.bg()}}></div>
          <div className='main-title-popup'>בטוח שאתם רוצים לצאת?</div>
          <h5 className='leave_text'>
            אם תרצו להשלים את ההצטרפות <br />
            בהמשך, תצטרכו להתחיל מחדש.
          </h5>

          <div className='btn-wrapper'>
            <BtnSubmit onclick={() => setShowLobbyPopup(false)} text='חזור לתהליך'></BtnSubmit>
          </div>

          <div className='btn-wrapper leave_link'>
            <BtnSubmit onclick={() => goToLobby()} text='לעמוד הבית'></BtnSubmit>
          </div>
        </div>
      </PopUp>

    </div>
  );
};

const mapStateToProps = (state) => ({
  currentPage: state.saleBlock.page,
  saleType: state.saleBlock.saleType,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SalesHeader);
